import { Component, OnInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Toast } from 'primeng/toast';
import { NgxBarcode6 } from 'ngx-barcode6';
import { PackageReceiveProgressComponent } from './package.receive.progress';
import { CardModule } from 'primeng/card';
import { NgxPrintModule } from 'ngx-print';

@Component({
   selector: 'package-receive-label',
   templateUrl: './package.receive.label.html',
   styleUrls: ['./step.css'],
   providers: [MessageService],
  imports: [Toast, NgxBarcode6, PackageReceiveProgressComponent, CardModule, NgxPrintModule]
})
export class PackageReceiveLabelComponent implements OnInit {

   package: PackageReceiveService;
  nextEnabled: boolean = false;

   constructor(private packageReceiveSvc: PackageReceiveService, private router: Router) {
      this.package = packageReceiveSvc;
      this.package.stepnumber = 5;
   }

   ngOnInit() {
      if (!this.package.trackingNumber) {
         this.router.navigate(['package-receive-new/package-receive-scan']);
      }
   }

   prevPage() {
      this.router.navigate(['package-receive-new/package-receive-client']);
   }

   nextPage() {
      this.router.navigate(['package-receive-new/package-receive-review']);
   }}
